<template>
  <div id="Mosaico">
    <div v-if="isLoading" class="loader">
      <div class="preloader-wrapper big active">
          <div class="spinner-layer spinner-white-only">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div><div class="gap-patch">
              <div class="circle"></div>
            </div><div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>
        </div>
    </div>

    <div v-if="!isLoading">
        <div v-masonry transition-duration="0.3s" item-selector=".item" class="masonry-container" 
            v-viewer="{
                inline: false, 
                navbar: true,
                toolbar: false,
                title: false,
                
            }"
        >
            <div v-masonry-tile class="item" v-for="img in imgs" :key="img.id">
            <!-- block item markup -->
            <img :src="'https://www.matteortili.com/imgs/portfolio/'+img.categoria+'/'+img.works_id+'.jpg'"
              :alt="'Celebration #' + img.works_id"
             />
            </div>
        </div>
    </div>
  </div>
</template>

<script async defer src="https://cdnjs.cloudflare.com/ajax/libs/masonry/4.0.0/masonry.pkgd.min.js"></script>
<script>
import Vue from 'vue'
import {VueMasonryPlugin} from 'vue-masonry';
Vue.use(VueMasonryPlugin);

import axios from 'axios'
import VueAxios from 'vue-axios'
 
Vue.use(VueAxios, axios)

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer);

export default{
    name: 'CelebrationMosaic',
    data () {
        return {
            isLoading: false,
            imgs: []
            }
    },
    methods:{
        allRecords: function(){
            axios.post('https://www.matteortili.com/scripts/dbRequest.php?id=1')
                .then(response => {
                  this.imgs = response.data;
                  this.isLoading = false;
                });
        }
    },
    mounted(){
        this.isLoading = true;
        this.allRecords();
    }
}   

</script>

<style scoped>
.masonry-container {
    width: 100%;
    margin: 0 auto;
}

  .grid-sizer,
  .item {
    width: 33.3333%;
  }
  @media (max-width: 892px){
    .grid-sizer,
    .item {
      width: 50%;
    }
  }

  @media (max-width: 450px){
    .grid-sizer,
    .item {
      width: 100%;
    }
  }

  .item {
    float: left;
  }

  .item img {
    display: block;
    width: 100%;
  }

   .item > img:hover {
    filter:grayscale(70%);
    cursor: pointer;
    transition: 300ms;
  }


    a{
      color: #222;
      text-decoration: none !important;
  }

  .cell-wrapper{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      cursor: pointer;
      background-color: rgba(250, 250, 250, 0.424);
      opacity: 0;
      color: rgb(15, 15, 15);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: opacity .2s ease-out;
  }

  .cell-wrapper:hover{
      opacity: 1;
  }

   .loader{
    margin-top: 5vh;
    margin-bottom: 5vh;
    text-align: center;
  }
</style>